<div class="content rounded-xl" [class]="type">
  <div class="label">
    <mat-icon>{{ iconName || type }}</mat-icon>
  </div>
  <div class="inner-content overflow-y-auto h-full">
    <ng-content></ng-content>
  </div>
</div>
